<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('back_to_job_management')">
              <button
              type="button"
              class="btn btn-sm btn-primary el-button--default"
              v-if="this.active < 6"
              @click="previous"
              style="float: right"
            >
              <span>Previous</span>
            </button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <job-index @jobId="setId" @createJob="createJob" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 2">
      <job-create :refresh="refresh" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 3">
      <job-edit :refresh="refresh" :id="job_id" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 4">
      <job-management :id="job_id" :active="{ active }"/>
    </el-form>
    <el-form v-if="active === 5">
      <job-bid-view :id="job_id" :active="{ active }"/>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "JobMain",
  data() {
    return {
      active: 1,
      id: 0,
      job_id: 0,
    };
  },
  methods: {
    createJob(id) {
        this.active = id;
      // console.info('create job function called -- ',id)
    },
    setId(id,value) {
      this.active = value;
      this.job_id = id;
      // console.info(value)

    },
    refresh() {
        this.active = 1;
    },
    previous() {
        if (this.active-- < 4) this.active = this.active--;
        this.active = 1;
    },
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
  },
  mounted() {
    // this.active = 1;
  },
};
</script>
